<div cdkDrag cdkDragBoundary="html" cdkDragRootElement=".cdk-overlay-pane" class="mat-typography" [class.folded]="folded">
  <pm-foldable-dialog-title mat-dialog-title (foldedChange)="this.onFoldedChange($event)">{{'dialog.search.title' | translate}}</pm-foldable-dialog-title>
  <div mat-dialog-content>
    <form>
      <mat-form-field class="search-field">
        <input matInput type="text" placeholder="{{'dialog.search.search' | translate}}" [formControl]="searchTextControl"
               name="searchField" tabindex="0" autofocus="autofocus">
        <mat-hint>{{'dialog.search.minimum-characters' | translate}}
          <a class="help-button" (click)="helpIsOpen = !helpIsOpen" cdkOverlayOrigin #origin="cdkOverlayOrigin"> {{'dialog.search.help.popup' | translate}} </a></mat-hint>
        @if(searchTextControl.errors?.invalidSearchTerms) {
          <mat-error>{{'dialog.search.error.invalid-terms' | translate }}</mat-error>
        }

        <mat-spinner matSuffix [class.proman-visible]="loading" [diameter]="18"></mat-spinner>
      </mat-form-field>
      <mat-checkbox [formControl]="searchExactControl">{{'dialog.search.exact' | translate}}</mat-checkbox>
      <mat-radio-group [formControl]="searchTypeControl" name="typeField">
        <span class="proman-header-label">{{'dialog.search.search-in.label' | translate}}</span>
        <div class="row">
          <div class="column">
            <mat-radio-button
              value="text">{{'dialog.search.search-in.processes-and-bullets' | translate}}</mat-radio-button>
            <mat-radio-button
              value="process">{{'dialog.search.search-in.processes' | translate}}</mat-radio-button>
            <mat-radio-button
              value="bullet">{{'dialog.search.search-in.bullets' | translate}}</mat-radio-button>
          </div>
          <div class="column">
            <mat-radio-button value="file">{{'dialog.search.search-in.document-names' | translate}}</mat-radio-button>
            <mat-radio-button value="info">{{'dialog.search.search-in.info' | translate}}</mat-radio-button>
          </div>
        </div>
      </mat-radio-group>
    </form>
    <mat-table class="mat-elevation-z4 pm-show-active" #table [dataSource]="dataSource" matSort matSortActive="label"
               matSortDirection="asc" matSortDisableClear (scroll)="onTableScroll($event)">
      <!-- Position Column -->
      <ng-container matColumnDef="label">
        <mat-header-cell class="proman-search-header" *matHeaderCellDef mat-sort-header> {{'dialog.search.table.label' |
          translate}}
        </mat-header-cell>
        <mat-cell class="proman-search-label" *matCellDef="let element" [title]="element.label"> {{element.label}}
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="path">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'dialog.search.table.path' | translate}}</mat-header-cell>
        <mat-cell class="proman-search-path" *matCellDef="let element"
                  [title]="element.path"> {{element.path}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="navigateToNode(row)"
               [class.active]="row.id === activeSearchElement"></mat-row>
    </mat-table>
  </div>
</div>

<!-- This template displays the overlay content and is connected to the button -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="helpIsOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  cdkConnectedOverlayBackdropClass="invisibleBackdrop"
  (backdropClick)="helpIsOpen = false"
  (detach)="helpIsOpen = false"
>
  <mat-card class="help-popup">
    <mat-card-header><h2 mat-card-title>{{ 'dialog.search.help.title' | translate }}</h2></mat-card-header>
    <mat-card-content>
      <span>{{'dialog.search.advanced.explanation' | translate }}</span>
      <mat-list role="list">
<!--
        <mat-list-item lines="3">
          <div matListItemIcon>+</div>
          <span matListItemTitle [innerHTML]="'dialog.search.advanced.explanation.plus' | translate"></span>
          <span matListItemLine class="help-example" [innerHTML]="'dialog.search.advanced.explanation.plus.example' | translate"></span>
        </mat-list-item>
-->
        <mat-list-item lines="3">
          <div matListItemIcon>-</div>
          <span matListItemTitle [innerHTML]="'dialog.search.advanced.explanation.minus' | translate"></span>
          <span class="help-example" [innerHTML]="'dialog.search.advanced.explanation.minus.example' | translate"></span>
        </mat-list-item>
        <mat-list-item lines="3">
          <div matListItemIcon>""</div>
          <span matListItemTitle [innerHTML]="'dialog.search.advanced.explanation.citation' | translate"></span>
          <span class="help-example" [innerHTML]="'dialog.search.advanced.explanation.citation.example' | translate"></span>
        </mat-list-item>
        <mat-list-item lines="3">
          <div matListItemIcon>*</div>
          <span matListItemTitle [innerHTML]="'dialog.search.advanced.explanation.asterisk' | translate"></span>
          <span class="help-example" [innerHTML]="'dialog.search.advanced.explanation.asterisk.example' | translate"></span>
        </mat-list-item>
        <div [innerHTML]="'dialog.search.exact.explanation' | translate"></div>
        <div class="help-example exact-example" [innerHTML]="'dialog.search.exact.explanation.example' | translate"></div>

      </mat-list>
    </mat-card-content>
  </mat-card>
</ng-template>
